import { useState } from 'react';
import CodFieldIcon, { defaultFieldIconName } from '../CodFieldIcon';
import { clampNumber, isHttpsUrl } from './style';
export const SAMPLE_VALUES = {
  first_name: "John",
};

export function FieldIconGraphic({ field }) {
  const [failedUrl, setFailedUrl] = useState("");
  const mode = field.icon_mode || "default";
  const customUrl = String(field.icon_url || "").trim();
  const iconName = field.icon_name || defaultFieldIconName(field.name);

  if (mode === "hidden") return null;
  if (mode === "custom" && isHttpsUrl(customUrl) && failedUrl !== customUrl) {
    return (
      <img
        src={customUrl}
        alt=""
        onError={() => setFailedUrl(customUrl)}
        referrerPolicy="no-referrer"
      />
    );
  }

  return <CodFieldIcon name={iconName} />;
}

export function PreviewField({ field, selected, editing, onSelect, dragHandlers, globalStyle, sampleValue: sampleValueOverride }) {
  const sampleValue = sampleValueOverride ?? SAMPLE_VALUES[field.name] ?? "";
  const showLabel = field.show_label !== false;
  const floating = showLabel && field.floating_label !== false;
  const showFloatingLabel = floating && Boolean(sampleValue);
  const showFixedLabel = showLabel && !floating;
  const placeholder = field.show_placeholder === false ? "" : field.placeholder;
  const showLeadingIcon = (field.icon_mode || "default") !== "hidden";
  const showTrailingIcon = field.type === "select" || field.name === "province_code";
  const fieldStyle = field.use_global_style === false ? field.style || {} : globalStyle;
  const visualStyle = {
    "--cfd-input-height": `${fieldStyle.input_height || globalStyle.input_height}px`,
    "--cfd-input-background": fieldStyle.input_background_color || globalStyle.input_background_color,
    "--cfd-input-border": fieldStyle.input_border_color || globalStyle.input_border_color,
    "--cfd-input-border-width": `${fieldStyle.input_border_width ?? globalStyle.input_border_width}px`,
    "--cfd-input-focus": fieldStyle.input_focus_border_color || globalStyle.input_focus_border_color,
    "--cfd-input-text": fieldStyle.text_color || globalStyle.text_color,
    "--cfd-label": fieldStyle.label_color || globalStyle.label_color,
    "--cfd-placeholder": fieldStyle.placeholder_color || globalStyle.placeholder_color,
    "--cfd-input-radius": `${fieldStyle.input_border_radius ?? globalStyle.input_border_radius}px`,
    "--cfd-icon-size": `${clampNumber(field.icon_size ?? 20, 12, 32)}px`,
  };

  return (
    <div
      className={`cfd-preview-field cfd-width-${field.width || "full"}${field.name === "discount_code" ? " cfd-discount-field" : ""}${editing ? " is-editing" : ""}${selected ? " is-selected" : ""}`}
      data-testid={`preview-field-${field.name}`}
      style={visualStyle}
      onClick={() => editing && onSelect(field.name)}
      draggable={editing}
      {...dragHandlers}
    >
      {editing ? (
        <button className="cfd-drag-handle" type="button" aria-label={`Drag ${field.label}`}>
          ⋮⋮
        </button>
      ) : null}
      <div className={`cfd-control${showFloatingLabel || showFixedLabel ? " has-label" : ""}${showLeadingIcon ? " has-leading-icon" : ""}${showTrailingIcon ? " has-trailing-icon" : ""}`}>
        {showLeadingIcon ? <span className="cfd-leading-icon"><FieldIconGraphic field={field} /></span> : null}
        {showFloatingLabel || showFixedLabel ? (
          <span className="cfd-control-label">
            {field.label}{field.required ? <b> *</b> : null}
          </span>
        ) : null}
        <span className="cfd-control-value">
          <span className={sampleValue ? "" : "is-placeholder"}>
            {sampleValue || placeholder || field.label}
          </span>
        </span>
        {showTrailingIcon ? <span className="cfd-chevron"><CodFieldIcon name="chevron-down" /></span> : null}
      </div>
      {field.help_text ? <small>{field.help_text}</small> : null}
      {field.name === "discount_code" ? <span className="cfd-discount-apply">Apply</span> : null}
      {selected && editing ? <span className="cfd-selection-tag">Field selected</span> : null}
    </div>
  );
}

export function PreviewProductInformation({ field, selected, editing, onSelect, dragHandlers, currency, decimalDigits }) {
  return (
    <div
      className={`cfd-preview-field cfd-width-full cfd-product-component${editing ? " is-editing" : ""}${selected ? " is-selected" : ""}`}
      data-testid="preview-field-product_information"
      onClick={() => editing && onSelect(field.name)}
      draggable={editing}
      {...dragHandlers}
    >
      {editing ? <button className="cfd-drag-handle" type="button" aria-label={`Drag ${field.label}`}>⋮⋮</button> : null}
      <div className="cfd-product-information">
        {field.show_image !== false ? (
          <svg className="cfd-product-image" viewBox="0 0 64 64" role="img" aria-label="Sample product image">
            <rect width="64" height="64" rx="8" fill="#edf4f8" />
            <path d="m17 22 15-8 15 8v21l-15 8-15-8z" fill="#d4a77a" />
            <path d="m17 22 15 8 15-8M32 30v21M24 18l15 8v9" fill="none" stroke="#9a6b3f" strokeWidth="2" />
          </svg>
        ) : null}
        <div className="cfd-product-description">
          <strong>Sample product</strong>
          {field.show_variant !== false ? <span>Blue / Standard</span> : null}
          {field.show_quantity !== false ? <span>Quantity: 1</span> : null}
          {field.show_price !== false ? <b>{(99).toFixed(decimalDigits ?? 2)} {currency || "USD"}</b> : null}
        </div>
      </div>
      {selected && editing ? <span className="cfd-selection-tag">Component selected</span> : null}
    </div>
  );
}
